import {DEFAULT_EMPTY_TOTAL_RESULTS} from './config.js'

export const getItemTotalResults = ({itemId, aggregations = []}) =>
  aggregations.find(({id}) => String(id) === String(itemId))?.totalResults || DEFAULT_EMPTY_TOTAL_RESULTS

export const mapSelectOption = ({items}) =>
  items.map(item => ({
    id: String(item.value),
    label: item.text
  }))

const isSameId = (idA, idB) => String(idA) === String(idB)

const isWholeMake = ({vehicle, defaultModelId}) => isSameId(vehicle.model?.id, defaultModelId)

const getWholeMakeIds = ({defaultModelId, vehicles}) =>
  vehicles.filter(vehicle => vehicle.makeId && isWholeMake({vehicle, defaultModelId})).map(({makeId}) => String(makeId))

// Excluding is only possible when nothing is added or at least one whole make is added
export const canExcludeVehicles = ({defaultModelId, vehicles}) => {
  const selectedVehicles = vehicles.filter(({makeId}) => makeId)
  return !selectedVehicles.length || Boolean(getWholeMakeIds({defaultModelId, vehicles: selectedVehicles}).length)
}

// With whole makes added, only the models of those makes can be excluded. Makes that already have
// exclusions stay visible so they can still be reviewed or removed.
export const getExcludableOptions = ({defaultModelId, excludedVehicles, options, vehicles}) => {
  const wholeMakeIds = new Set(getWholeMakeIds({defaultModelId, vehicles}))
  if (!wholeMakeIds.size) return options

  const excludedMakeIds = new Set(excludedVehicles.map(({makeId}) => String(makeId)))

  return options
    .filter(({id}) => wholeMakeIds.has(String(id)) || excludedMakeIds.has(String(id)))
    .map(option => (wholeMakeIds.has(String(option.id)) ? {...option, allowsAllModels: false} : option))
}

// Adding a make (or one of its models) takes over the exclusions it conflicts with.
// Removing a make entirely also clears its exclusions.
export const removeConflictingExclusions = ({defaultModelId, excludedVehicles, makeId, newVehicles}) => {
  if (!newVehicles.length) return excludedVehicles.filter(excluded => !isSameId(excluded.makeId, makeId))

  const isAddingWholeMake = newVehicles.some(vehicle => isWholeMake({vehicle, defaultModelId}))
  const addedModelIds = new Set(newVehicles.map(({model}) => String(model?.id)))

  return excludedVehicles.filter(excludedVehicle => {
    if (!isSameId(excludedVehicle.makeId, makeId)) return true
    if (isAddingWholeMake) return false
    if (isWholeMake({vehicle: excludedVehicle, defaultModelId})) return false
    return !addedModelIds.has(String(excludedVehicle.model?.id))
  })
}

export const getVehiclesLabel = vehicles =>
  vehicles
    .map(({make, model}) => `${make || ''} ${model?.name || ''}`.trim())
    .filter(Boolean)
    .join(', ')
